module.exports = __webpack_public_path__ + "static/media/P11.85861501.png";